import React, { useEffect, useState } from "react";
import { getAdminConsultationMode } from "../../utils/consultationMode";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
// import { SiMicrosoftexcel } from "react-icons/si";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
    bookedWaitlistApi,
  getUserHistoryApi,
  getUserListApi,
  logoutUserFromAllDevice,
  sendOtpAPi,
  waitlistApi,
  //   verifyOtpApi,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from "../userManagement/UserStatus";
import { dateFormat, dateFormatUtc, formatDuration } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF'
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField, Typography } from "@mui/material";
import constants from "../../utils/constants";

// Utility function to calculate age from date of birth
const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return "---";
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    if(age < 0) {
        return "---";
    }
    
    return age;
};

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;


// console.log('Gender', gender)

const BookedWaitlistManagement = () => {
    let URL = constants.SERVER_API
    const [searchParam, setSearchParam] = useSearchParams()
    const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
    const [activePage, setActivePage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10); // Add page limit state
    const [search, setSearch] = useState("");
    const debounceValue = useDebounce(search || "", 300);
    const [total, setTotal] = useState(0);
    const [userList, setUserList] = useState([]);
    const [problemList, setProblemList] = useState([]);
    const [statusModal, setStatusModal] = useState(false);
    const [statusValue, setStatusValue] = useState("");
    const [statusId, setStatusId] = useState("");
    const [logoutUserModel, setLogoutUserModel] = useState(false);

    const [buttonref, buttonLoader] = useButtonLoader("Logout");

    const [WriteOtpModal, setwriteOtpModal] = useState(false);
    
    // Filter states
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [userAge, setUserAge] = useState("");
    const [userGender, setUserGender] = useState("");
    const [consultationMode, setConsultationMode] = useState("");
    const [consultationType, setConsultationType] = useState("");
    const [problem, setProblem] = useState("");
    const [consultantGender, setConsultantGender] = useState("");
    const [status, setStatus] = useState("");
    
    // Time range filter states
    const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
    const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
    const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");
    
    // Time range options
    const timeRangeOptions = [
        { value: "today", label: "Today" },
        { value: "yesterday", label: "Yesterday" },
        { value: "last7days", label: "Last 7 Days" },
        { value: "last30days", label: "Last 30 Days" },
        { value: "thisMonth", label: "This Month" },
        { value: "lastMonth", label: "Last Month" },
        { value: "custom", label: "Custom Range" }
    ];

    // Page limit options
    const pageLimitOptions = [
        { value: 5, label: "5 per page" },
        { value: 10, label: "10 per page" },
        { value: 25, label: "25 per page" },
        { value: 50, label: "50 per page" },
        { value: 100, label: "100 per page" }
    ];

  const handleLogoutHandler = async () => {
    try {
      buttonLoader(true);
      const sendData = { userId: statusId };
      const { data } = await logoutUserFromAllDevice(sendData);
      if (data.code === 200) {
        console.log("Date", data);
        logoutCloseModel();
      } else {
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  };

  // handle all hooks
  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/user/download/waitlist`;
      const params = {
        filter: {}
      };
      
      // Add all current filters to the export
      if(search) {
        params.filter.search = search;
      }
      if (startDate) {
        params.filter.startDate = dateFormatUtc(startDate);
      }
      if (endDate) {
        params.filter.endDate = dateFormatUtc(endDate);
      }
      if (userAge) {
        params.filter.userAge = userAge;
      }
      if (userGender) {
        params.filter.userGender = userGender;
      }
      if (consultationMode) {
        params.filter.consultationMode = consultationMode;
      }
      if (consultationType) {
        params.filter.consultationType = consultationType;
      }
      if (problem) {
        params.filter.problem = problem;
      }
      if (consultantGender) {
        params.filter.consultantGender = consultantGender;
      }
      if (status) {
        params.filter.status = status;
      }
      if (timeRange) {
        params.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        params.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        params.filter.timeRangeEndDate = timeRangeEndDate;
      }
      
      requestDownload(url, `booked-waitlist-${dateFormat(new Date())}.csv`, params);
    } catch (e) {
      console.log(e.message);
    }
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  //*********Logout handler function********* */
  const userLogoutHandler = (id) => {
    setStatusId(id);
    setLogoutUserModel(true);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    setActivePage(event);
    getUserList(event);
  };

  //*********Handle Page Limit Change********* */
  const handlePageLimitChange = (event) => {
    const newLimit = parseInt(event.target.value);
    setPageLimit(newLimit);
    setActivePage(1); // Reset to first page when changing limit
  };
  
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setActivePage(1);
    setPageLimit(10); // Reset page limit to default
    setStartDate(null);
    setEndDate(null);
    setUserAge("");
    setUserGender("");
    setConsultationMode("");
    setConsultationType("");
    setProblem("");
    setConsultantGender("");
    setStatus("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    getUserList();  
  };

  // Time range handler
  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
    if (value !== 'custom') {
      setTimeRangeStartDate("");
      setTimeRangeEndDate("");
    }
  };

  // Time range date change handler
  const handleTimeRangeDateChange = (type, value) => {
    if (type === 'start') {
      setTimeRangeStartDate(value);
    } else {
      setTimeRangeEndDate(value);
    }
  };

  // Apply filter function
  const applyFilter = () => {
    setActivePage(1); // Reset to page 1 when applying filters
    getUserList(1);
  };
  //------------------usre-listing-Api----------------------------------
  const getUserList = async (page=1) => {
    try {
      showLoader();
      const sendData = {
        page: `${page}`,
        limit: `${pageLimit}`,
        filter: {}
      };

      if(search) {
        sendData.filter.search = search;
      }
      if (startDate) {
        sendData.filter.startDate = dateFormatUtc(startDate);
      }
      if (endDate) {
        sendData.filter.endDate = dateFormatUtc(endDate);
      }
      if (userAge) {
        sendData.filter.userAge = userAge;
      }
      if (userGender) {
        sendData.filter.userGender = userGender;
      }
      if (consultationMode) {
        sendData.filter.consultationMode = consultationMode;
      }
      if (consultationType) {
        sendData.filter.consultationType = consultationType;
      }
      if (problem) {
        sendData.filter.problem = problem;
      }
      if (consultantGender) {
        sendData.filter.consultantGender = consultantGender;
      }
      if (status) {
        sendData.filter.status = status;
      }
      if (timeRange) {
        sendData.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        sendData.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        sendData.filter.timeRangeEndDate = timeRangeEndDate;
      }

      const { data } = await bookedWaitlistApi(sendData);
      if (data.code === 200) {
        console.log('data ===>', data.result.list)
        console.log("remainingCoins ===>");
        data.result.list.map((user, index) => {
          console.log(`User ${index + 1}:`, user.remainingCoins);
        });
        setUserList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        // scrollToUp();
      } else {
        setUserList([]);
        setTotal(0);
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  const logoutCloseModel = () => {
    setLogoutUserModel(false);
    setStatusId("");
  };

  // problem list handler function

  const fetchProblemHandler = async () => {
    try {
      showLoader();
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setProblemList(data?.result?.categoryList || []);
      } else {
        setProblemList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };



  const handleRegistrationDate = (date) => {
    const utcDateString = dateFormatUtc(date);
    searchParam.delete("page");
    searchParam.set("registrationDate", utcDateString);
    setSearchParam(searchParam);
  };

  useEffect(() => {
    getUserList(activePage);
    fetchProblemHandler();
  }, [activePage, pageLimit]);
  return (
    <>
      <OTPModalCNF verifiedHandle={() => {
        console.log('OTP Verified Successfully!')
      }} />
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            {/* <div className="user_management_heading"> */}
            <h4 className="Title">Booked Session-Waitlist Management</h4>
            <div className="block_user_button">
              <SecondaryButton 
                onClick={handleExcelDownload}
                disabled={loading}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 16px',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    <div className="csv-image-wrapper" style={{ width: '16px', height: '16px' }}>
                      <img src={csv} alt="csv file download" style={{ width: '100%', height: '100%' }} />
                    </div>
                    Export CSV
                  </>
                )}
              </SecondaryButton>
            </div>
            {/* </div> */}
          </div>
          <div className="FilterBox FilterArea" style={{ flexDirection: 'column' }}>
            {/* Row 1: Search Bar and Basic Filters */}
            <div className="group_filter_value" style={{ 
              marginBottom: '15px', 
              display: 'flex !important', 
              flexWrap: 'wrap !important', 
              gap: '15px', 
              alignItems: 'center',
              width: '100%',
              flexDirection: 'row'
            }}>
              {/* Search Bar */}
              <div className="form-group search_md_size userSearch" style={{ minWidth: '200px', flex: '1 1 auto' }}>
                <input
                  type="search"
                  className={`form-control ${search && "active"}`}
                  placeholder="Search"
                  value={search || ""}
                  style={{ "--color": "#FF8989" }}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>


              {/* Mode of Consultation */}
              <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                <Select
                  className={`form-control ${consultationMode && "active"}`}
                  value={consultationMode}
                  onChange={(e) => setConsultationMode(e.target.value)}
                >
                  <option value="">Mode of Consultation</option>
                  <option value="call">Call</option>
                  <option value="chat">Chat</option>
                </Select>
              </div>

           
              {/* Problem */}
              <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                <Select
                  className={`form-control ${problem && "active"}`}
                  value={problem}
                  onChange={(e) => setProblem(e.target.value)}
                >
                  <option value="">Problem</option>
                  {problemList &&
                    problemList.length > 0 &&
                    problemList.map((problemItem, index) => {
                      return (
                        <option value={problemItem.title} key={problemItem._id}>
                          {problemItem.title}
                        </option>
                      );
                    })}
                </Select>
              </div>

        
              {/* Status */}
              <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                <Select
                  className={`form-control ${status && "active"}`}
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">Status</option>
                  <option value="waiting  ">Pending</option>
                  <option value="progress">Progress</option>
                  <option value="completed">Completed</option>
                  <option value="canceled">Cancelled</option>
                </Select>
              </div>

              {/* Time Range Filter */}
              <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Time Range</InputLabel>
                  <MuiSelect
                    value={timeRange}
                    onChange={(e) => handleTimeRangeChange(e.target.value)}
                    label="Time Range"
                  >
                    <MenuItem value="">
                      <em>All Time Ranges</em>
                    </MenuItem>
                    {timeRangeOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
              </div>
              
              {timeRange === 'custom' && (
                <>
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      label="Start Date"
                      value={timeRangeStartDate}
                      onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      label="End Date"
                      value={timeRangeEndDate}
                      onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </>
              )}

              {/* Apply Filter & Refresh */}
              <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                <SecondaryButton onClick={applyFilter}>
                  Apply
                </SecondaryButton>
                <SecondaryButton onClick={refreshHandler}>
                  Clear
                </SecondaryButton>
              </div>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  {/* <th>User Id</th> */}
                  {/* <th>Profile</th> */}
                  <th>Created At</th>
                  <th>User Name</th>
                  <th>User Id</th>
                  <th>User Mobile</th>
                  <th>User Gender</th>
                  <th>Consultant Name</th>
                  <th>Consultant Mobile</th>

                  <th>Mode of Consultation</th>
                  <th>Slot Time</th>
                  <th>Slot Duration</th>
                  <th>Status</th>
                  {/* <th className="text-center"> Action </th>
                  <th>Logout from all Device</th> */}
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((user, index) => {
                    console.log("user ===>", user)
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, pageLimit)}</td>
                          {/* <td>{user?._id}</td> */}
                          {/* <td className="user_profile_image">
                            <img
                              src={user.profileImage || profileImage}
                              alt={`${user.name} profile image`}
                            />
                          </td> */}
                          <td>{dateFormat(user.createdAt) || "---"}</td>
                          <td><Link to={`${USER_DETAIL}/${user?.user_id}`}>{user?.request_form?.firstName || "---"}</Link></td>
                          <td>{user?.userDetails?.userId || "---"}</td>
                          <td>
                            {user?.userDetails?.mobile ? (
                              <a href={`tel:${user?.userDetails?.mobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                {user?.userDetails?.mobile}
                              </a>
                            ) : (
                              "---"
                            )}
                          </td>
                          <td>
                            {user.request_form?.gender
                              ? CapitalizeFirstWord(user.request_form?.gender)
                              : "---"}
                          </td>
                          <td><Link to={`/consultant-management/consultant-detail/${user?.consultant_id}`}>{user?.consultantDetails?.accountName}</Link></td>
                          <td>
                            {user?.consultantDetails?.mobile ? (
                              <a href={`tel:${user?.consultantDetails?.mobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                {user?.consultantDetails?.mobile}
                              </a>
                            ) : (
                              "---"
                            )}
                          </td>
                          <td>{getAdminConsultationMode(user)}</td>
                          <td>
                            {
                              user.session_info?.sessionMeta?.timeFrom
                                ? user.session_info?.sessionMeta?.timeFrom
                                : "---"
                            }  - {
                              user.session_info?.sessionMeta?.timeTo
                                ? user.session_info?.sessionMeta?.timeTo
                                : "---"
                            }
                          </td>
                          <td>{
                            user?.session_info?.sessionMeta?.sessionTimeInMinutes 
                              ? (user?.session_info?.sessionMeta?.sessionTimeInMinutes) + " minutes"
                              : "---"
                          }</td>
                          <th>{user?.status}</th>
                          {/* <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>

                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  statusUpdateHandler(user._id, user.status)
                                }
                              />
                            </div>
                          </td> */}
                          {/* <td>
                            <div className="block_user_button">
                              <button
                                className="mx-4"
                                onClick={() => userLogoutHandler(user._id)}
                              // ref={buttonref}
                              >
                                Logout
                              </button>
                            </div>
                          </td> */}
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={9}
                    msg="User not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <Typography variant="body2" color="textSecondary">
                Show:
              </Typography>
              <select
                value={pageLimit}
                onChange={(e) => handlePageLimitChange(e)}
                style={{ 
                  padding: '8px 12px', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '80px'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <Typography variant="body2" color="textSecondary">
                 per page
              </Typography>
            </div>
            
            <div className="d-flex align-items-center gap-2">
              <Typography variant="body2" color="textSecondary">
                Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
              </Typography>
            </div>
            
            {total > pageLimit && (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={pageLimit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setListing={setUserList}
          setUserDetail={""}
          status={statusValue}
          id={statusId}
        />
      )}

      {logoutUserModel && (
        <ModalBox
          status={logoutUserModel}
          onClose={logoutCloseModel}
          title="Logout User from all Device"
          description="Do you want to logout the user from all the devices?"
          action={handleLogoutHandler}
          ref={buttonref}
        />
      )}

      <DownloadPasswordModal />
    </>
  );
};

export default BookedWaitlistManagement;
